export default __webpack_public_path__ + "static/media/in-review-requests-icon.0af94856.svg";